export function loadAiTranslatePlugin() {
  const translations = {
    en: {
      item1: 'English',
      item2: 'German (Sie)',
      item3: 'German (du)',
      item4: 'French',
      item5: 'Spanish',
      item6: 'Italian',
      item7: 'Polish',
      item8: 'Romanian',
      item9: 'Czech',
      item10: 'Dutch'
    },
    fr: {
      item1: 'Anglais',
      item2: 'Allemand (Sie)',
      item3: 'Allemand (du)',
      item4: 'Français',
      item5: 'Espagnol',
      item6: 'Italien',
      item7: 'Polonais',
      item8: 'Roumain',
      item9: 'Tchèque',
      item10: 'Néerlandais'
    },
    es: {
      item1: 'Inglés',
      item2: 'Alemán (Sie)',
      item3: 'Alemán (du)',
      item4: 'Francés',
      item5: 'Español',
      item6: 'Italiano',
      item7: 'Polaco',
      item8: 'Rumano',
      item9: 'Checo',
      item10: 'Neerlandés'
    },
    de: {
      item1: 'Englisch',
      item2: 'Deutsch (Sie)',
      item3: 'Deutsch (du)',
      item4: 'Französisch',
      item5: 'Spanisch',
      item6: 'Italienisch',
      item7: 'Polnisch',
      item8: 'Rumänisch',
      item9: 'Tschechisch',
      item10: 'Niederländisch'
    },
    it: {
      item1: 'Inglese',
      item2: 'Tedesco (Sie)',
      item3: 'Tedesco (du)',
      item4: 'Francese',
      item5: 'Spagnolo',
      item6: 'Italiano',
      item7: 'Polacco',
      item8: 'Rumeno',
      item9: 'Ceco',
      item10: 'Olandese'
    },
    pl: {
      item1: 'Angielski',
      item2: 'Niemiecki (Sie)',
      item3: 'Niemiecki (du)',
      item4: 'Francuski',
      item5: 'Hiszpański',
      item6: 'Włoski',
      item7: 'Polski',
      item8: 'Rumuński',
      item9: 'Czeski',
      item10: 'Niderlandzki'
    },
    ro: {
      item1: 'Engleză',
      item2: 'Germană (Sie)',
      item3: 'Germană (du)',
      item4: 'Franceză',
      item5: 'Spaniolă',
      item6: 'Italiană',
      item7: 'Poloneză',
      item8: 'Română',
      item9: 'Cehă',
      item10: 'Olandeză'
    },
    cz: {
      item1: 'Anglický',
      item2: 'Německý (Sie)',
      item3: 'Německý (du)',
      item4: 'Francouzský',
      item5: 'Španělský',
      item6: 'Italský',
      item7: 'Polský',
      item8: 'Rumunský',
      item9: 'Český',
      item10: 'Nizozemský'
    },
    nl: {
      item1: 'Engels',
      item2: 'Duits (Sie)',
      item3: 'Duits (du)',
      item4: 'Frans',
      item5: 'Spaans',
      item6: 'Italiaans',
      item7: 'Pools',
      item8: 'Roemeens',
      item9: 'Tsjechisch',
      item10: 'Nederlands'
    }
  };

  FroalaEditor.PLUGINS.aiTranslate = function (editor) {
    return {
      dropdownCallback: function (cmd, val) {
        const options = FroalaEditor.COMMANDS['aiTranslate'].options();
        const languageLabel = options[val];
        editor.events.trigger('aiTranslate.itemClicked', [languageLabel]);
      }
    };
  };

  FroalaEditor.DefineIcon('translateIcon', {
    SRC: '/assets/images/froala-plugins/translate.icon.png',
    ALT: 'Translate',
    template: 'image'
  });

  FroalaEditor.RegisterCommand('aiTranslate', {
    title: 'Translate',
    type: 'dropdown',
    icon: 'translateIcon',

    options: function () {
      const editor = FroalaEditor.INSTANCES[0];
      const lang = editor?.opts?.language || 'en';
      return translations[lang] || translations['en'];
    },

    callback: function (cmd, val) {
      this.aiTranslate.dropdownCallback(cmd, val);
    },

    refresh: function ($btn) {
      const selectedText = this.selection?.get()?.toString() || '';
      if (!selectedText.trim()) {
        $btn.addClass('fr-disabled');
      } else {
        $btn.removeClass('fr-disabled');
      }
    }
  });
}
